const ru = {
  firstSentence:
    '"Этот проект является моим вкладом в общество. Здесь я трачу большую часть своего свободного времени без коммерческого интереса.',
  highlightedSentence: 'Все здесь всегда будет бесплатно.',
  secondSentence: 'Учитесь. Развивайтесь. Делитесь."',
};

export default ru;
